import { Navigate } from "react-router-dom";
import {
  getAccessibleApplications,
  getApplicationRoute,
  hasAdminRole,
  parseStoredAppRoleIds,
  parseStoredRoleIds,
} from "../utils/authAccess";

const ProtectedRoute = ({ children, requiredApp = null, requireAdmin = false }) => {
  const isAuthenticated = localStorage.getItem("authenticated") === "true";
  const loginTimestamp = parseInt(localStorage.getItem("loginTimestamp"), 10);
  const expiresIn = parseInt(localStorage.getItem("expiresIn"), 10);
  const roleIds = parseStoredRoleIds(localStorage.getItem("roleId"));
  const appRoleIds = parseStoredAppRoleIds(localStorage.getItem("appRoleIds"));
  const accessibleApplications = getAccessibleApplications(appRoleIds);

  const now = Date.now();
  const isExpired =
    !Number.isFinite(loginTimestamp) ||
    !Number.isFinite(expiresIn) ||
    now - loginTimestamp > expiresIn;

  if (!isAuthenticated || isExpired) {
    localStorage.clear(); // Clear everything if expired
    return <Navigate to="/login" replace />;
  }

  if (requiredApp && !accessibleApplications.includes(requiredApp)) {
    if (accessibleApplications.length === 1) {
      return (
        <Navigate to={getApplicationRoute(accessibleApplications[0])} replace />
      );
    }

    if (accessibleApplications.length > 1) {
      return <Navigate to="/application-selector" replace />;
    }

    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !hasAdminRole(roleIds)) {
    if (accessibleApplications.length === 1) {
      return (
        <Navigate to={getApplicationRoute(accessibleApplications[0])} replace />
      );
    }

    return <Navigate to="/application-selector" replace />;
  }

  return children;
};

export default ProtectedRoute;
